import * as React from 'react';
import * as RB from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import * as DTO from '../service/DTOs';
import * as TF from '../service/tradeflow';

//import { Highlighter } from 'react-bootstrap-typeahead';

import 'isomorphic-fetch';


interface SecItemState {
    //key: string;
    sec: DTO.Security;
    loading?: boolean;
}

type SecItemProps = SecItemState & { xsrfToken?: string };

const initialstate: SecItemState = {
    //key: '',
    sec: { id: 0, isin: '', logo_url: '', name: '', secid: '', shortname: '' },
    loading: false
}



export class SecurityListItem extends React.Component<SecItemProps, SecItemState> {
    constructor(props: SecItemProps) {
        super(props);
        //, key: props.key
        this.state = {
            ...initialstate, ...{ sec: props.sec }
        };
    }

    public render() {
            //<img
            //    alt={this.props.sec.secid}
            //    src={this.props.sec.logo_url}
            //    style={{
            //        height: '24px',
            //        marginRight: '10px',
            //        width: '24px',
            //    }}
            ///>

        //<div name={this.props.key}>
        //    <span>{this.props.sec.secid}</span><span>  </span><span>({this.props.sec.isin})</span>
        //    <span>{this.props.sec.name}</span>
        //</div>;


        return <div>
            {this.props.sec.name}
            <div>
                <small><b>SECID:</b>{this.props.sec.secid}</small>{' '}<small><b>ISIN:</b>{this.props.sec.isin}</small>
            </div>
        </div>;
    }

}



interface EntityItemState {
    entity: DTO.EntityDto;
    loading?: boolean;
}

type EntityItemProps = EntityItemState & { xsrfToken?: string };

const initialstateEntity: EntityItemState = {
    entity: { id:0, addressfact: '', addresslegal: '', email: '', fax: '', fullname: '', shortname: '', idcountry: 0, phone: '', reutercode: '' },
    loading: false
}



export class EntityListItem extends React.Component<EntityItemProps, EntityItemState> {
    constructor(props: EntityItemProps) {
        super(props);
        this.state = {
            ...initialstateEntity, ...{ entity: props.entity }
        };
    }

    public render() {

        return <div>
            {this.props.entity.shortname}
            <div>
                <small><b>Название:</b>{this.props.entity.fullname}</small>
            </div>
            <div>
                <small><b>Адрес:</b>{this.props.entity.addresslegal}</small>{' '}<small><b>Reuter:</b>{this.props.entity.reutercode}</small>
                {this.props.entity.bloombergcode ? <small><b>Reuter:</b>{this.props.entity.bloombergcode }</small>: ''}
            </div>
        </div>;
    }

}

